import React, { Fragment } from 'react';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ZAxis, Label, Legend } from 'recharts';


const RiskVSReward = ({ data }) => {


  const filteredActiveFunds = data.filter((d) => { return d.type === "ACTIVE" });
  const mappedActiveFunds = filteredActiveFunds.map((d) => { return { "x": d.std_dev_5_year, "y": d.total_5_year_ret, "z": 20 }; });

  const filteredPassiveFunds = data.filter((d) => { return d.type === "PASSIVE05" });
  const mappedPassiveFunds = filteredPassiveFunds.map((d) => { return { "x": d.std_dev_5_year, "y": d.total_5_year_ret, "z": 100 }; });

  return (
    <Fragment>
      <h3>Risk vs Reward</h3>
      <ResponsiveContainer width="100%" height={400}>
        <ScatterChart
          margin={{
            top: 20,
            right: 20,
            bottom: 20,
            left: 20,
          }}
        >
          <CartesianGrid />
          <XAxis type="number" dataKey="x" name="risk" unit=""><Label value="Risk (1/3/5 yr Weighted Standard Deviation)" offset={-10} position="insideBottomLeft" /></XAxis>
          <YAxis type="number" dataKey="y" name="reward" unit="%"><Label value="Reward" angle={-90} offset={7} position="left" /></YAxis>
          <ZAxis type="number" dataKey="z" range={[0, 75]} name="Blob Size" unit="blobs" />
          <Legend />
          <Scatter name="5 Year Active" data={mappedActiveFunds} fill="grey" />
          <Scatter name="5 Year Passive" data={mappedPassiveFunds}  fill="black" />
        </ScatterChart>
      </ResponsiveContainer>
    </Fragment>
  );

};

export default RiskVSReward;